// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dark-stroke[data-v-87f5cf3e]{stroke-dasharray:200%;stroke-dashoffset:140%;transform-box:fill-box;transform-origin:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
